const generateTimeStamp = () => new Date().toISOString().split('T')[1].split('Z')[0];

export const dbgMessages = [
    {
        topic: "",
        timestamp: generateTimeStamp(),
        text: "",
        err: false,
        caution: false,
    }
];

dbgMessages.add = function({ topic = '', text = '', err = false, caution = false } = {}) {
    return this.push({
        topic,
        timestamp: generateTimeStamp(),
        text,
        err,
        caution
    });
};

dbgMessages.clear = function() {
    this.length = 0;
};

dbgMessages.hasErrors = function() {
    return this.some(msg => msg.err);
};

dbgMessages.hasWarnings = function() {
    return this.some(msg => msg.caution);
};

dbgMessages.log = function(what = 'all') {
    // let data;
    // switch (what) {
    //     case 'errors':
    //         data = this.errors;
    //         break;
    //     case 'warnings':
    //         data = this.warnings;
    //         break;
    //     case 'topics':
    //         data = this.topics;
    //         break;
    //     default:
    //         data = this.map(msg => ({ ...msg }));
    // }
    // same thing as above but less verbose
    const data = typeof this[ what ] === 'object' ? this[what] : this.map(msg => ({ ...msg })) ;
    console.table(data);
};

Object.defineProperties(dbgMessages, {
    warnings: {
        get() {
            return this.filter(msg => msg.caution).map(msg => ({ ...msg }));
        }
    },
    errors: {
        get() {
            return this.filter(msg => msg.err).map(msg => ({ ...msg }));
        }
    },
    topics: {
        get() {
            return this.filter(msg => !msg.err && !msg.caution).map(msg => ({ topic: msg.topic, timestamp: msg.timestamp }));
        }
    }
});


